export const pageHeader = "My Blog"
export const pageSubheader = 'console.log(\'Hello, User!\');'

export const endpoints = {
  registration: 'https://us-central1-blog-43f84.cloudfunctions.net/userRegistration',
  getUsers: 'https://us-central1-blog-43f84.cloudfunctions.net/getUsers',
};

export const pageUrl = 'https://blog-43f84.web.app';
